export const FILTER_GAMES = {
  ALL: 0, // Все игры
  FILTER: 1, // Игры, участвующие в акции
  EXCLUDE: 2, // Игры, не участвующие в акции
  GROUP_FILTER: 3, // Группы игр, участвующие в акции
  GROUP_EXCLUDE: 4, // Группы игр, не участвующие в акции
  ONLY_SPORT: 5, // Только спорт
}
